import { getAppliedFacetItemIds, getFacetById } from 'app/products/productsReducer';
import { connect } from 'react-redux';
import Facet from './facet';
import { applyFacetItem, removeFacetItem } from '../facetsListActions';

const mapStateToProps = (state, { facetId }) => ({
  hasAppliedItems: !!getAppliedFacetItemIds(state, facetId).length,
  facet: getFacetById(state, facetId),
});

const mapDispatch = {
  applyFacetItem,
  removeFacetItem,
};

export default connect(
  mapStateToProps,
  mapDispatch
)(Facet);
